import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const ConfettiIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 24, height = 24, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M4 5H6M5 4V6M11.5 4L11 6M18 5H20M19 4V6M15 9L14 10M18 13L20 12.5M18 19H20M19 18V20M14 16.518L7.48205 10L3.09205 19.58C3.00528 19.766 2.97785 19.9742 3.01347 20.1763C3.0491 20.3785 3.14605 20.5647 3.29118 20.7099C3.43632 20.855 3.62259 20.952 3.82472 20.9876C4.02685 21.0232 4.23505 20.9958 4.42105 20.909L14 16.518Z"
          stroke="#FF9D0A"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
